<template>
  <section class="additional-resource">
    <article v-for="resource in resources" class="additional-resource__card">
      <a :href="resource.url" class="additional-resource__card" target="_blank">
        <div class="additional-resource__image-container">
          <img
            :src="getImageUrl(resource.image)"
            :alt="resource.title"
            class="additional-resource__image"
          />
        </div>
        <h3 class="additional-resource__title">{{ resource.title }}</h3>
      </a>
    </article>
  </section>
</template>

<script>
  export default {
    name: 'AdditionalResourceComponent',
    props: {
      resources: {
        type: Array,
        required: true,
      },
    },
    methods: {
      getImageUrl(image) {
        // check if the image url starts with a slash and add one if it doesn't
        // if (image && !image.startsWith('/')) {
        //   return `/${encodeURI(image)}`
        // }
        return image ? encodeURI(image) : '/images/itr-logo.png';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .additional-resource {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    @media (min-width: 768px) {
      grid-template-rows: repeat(1, 1fr);
      grid-template-columns: repeat(4, 1fr);
    }

    &__card {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      &:hover {
        text-decoration: none;
      }
    }
    &__card:hover .additional-resource__image-container {
      transform: scale(1.1);
      transition: transform 0.3s ease-in-out;
    }
    &__image-container {
      position: relative;
      border-radius: 50%;
      border: 10px solid var(--itr-grey-soft);
      // box-shadow: 0 0 0 3px var(--itr-white), 0 0 0 10px var(--itr-grey-soft);
      overflow: hidden;
      transition: transform 0.3s ease-in-out;
      height: 115px;
      width: 115px;
      @media (min-width: 500px) {
        height: 145px;
        width: 145px;
      }
      @media (min-width: 1200px) {
        width: 200px;
        height: 200px;
      }
    }
    &__image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    &__title {
      margin-top: 1.5rem;
      font-size: 18px;
      font-weight: 900;
      color: var(--itr-blue-mid);
      text-align: center;
    }
  }
</style>
